/**
 * MODULE: domain/sales-intelligence/frontend/services/contextService.ts
 * PURPOSE: Service for seller context API calls (JIT context collection)
 */

import { salesIntelligenceApi } from '../api/client';
import type { SellerCompanyProfile } from '../../contracts/sales-intelligence.types';
import type { SellerContextResponse, SellerQuickSetupFormState } from '../types/seller-context';

/**
 * Check if seller context exists for tenant
 */
export async function checkSellerContext(): Promise<SellerContextResponse> {
  const data = await salesIntelligenceApi.checkContext();
  return {
    exists: data.exists,
    isComplete: data.isComplete ?? false,
    missingFields: data.missingFields ?? [],
    profile: data.profile
  };
}

/**
 * Save quick setup context (sends snake_case payload to backend)
 */
export async function saveQuickSetupContext(
  data: SellerQuickSetupFormState
): Promise<{ success: boolean; profile_id: string }> {
  const payload = {
    company_name: data.companyName,
    value_prop: data.valueProp,
    target_industries: data.targetIndustries,
    ideal_size: data.idealSize,
    pain_points: data.painPoints,
    integrations: data.integrations,
    competitors: data.competitors
  };
  const result = await salesIntelligenceApi.saveQuickSetupContext(payload);
  return { success: result.success, profile_id: result.profile_id };
}

/**
 * Get full seller profile
 */
export async function getSellerProfile(): Promise<SellerCompanyProfile> {
  return salesIntelligenceApi.getSellerProfile();
}

/**
 * Delete seller profile
 */
export async function deleteSellerProfile(): Promise<void> {
  await salesIntelligenceApi.deleteSellerProfile();
}
